import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getChargeGroupList(params) {
  return request({
    url: URL.mdm.basicData.chargeGroup,
    method: 'get',
    params
  })
}

export function saveChargeGroup(data) {
  return request({
    url: URL.mdm.basicData.chargeGroup,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delChargeGroup(uuid) {
  return request({
    url: URL.mdm.basicData.chargeGroup + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

